import {customElement, property} from 'lit/decorators.js';
import {html, LitElement} from 'lit';
import { style } from './slider-control.styles'

@customElement('sbk-slider-control')
export class SbkSliderControl extends LitElement {

  @property()
  label: string = '';

  @property({attribute: 'next-label'})
  nextLabel: string = '';

  @property({attribute: 'prev-label'})
  prevLabel: string = '';

  @property({type: Number, attribute: 'current-slide'})
  currentSlide: number = 0;

  @property({type: Number, attribute: 'total-slides'})
  totalSlides: number = 0;

  static get styles() {
    return style;
  }

  render() {
    if (this.totalSlides && this.totalSlides < 1) {
      return '';
    }
    return html`
      <nav role="navigation" class="slider-control" aria-label=${this.label}>
        ${this.renderPrevButton()}
        ${this.renderSlideIndicators()}
        ${this.renderNextButton()}
      </nav>
    `;
  }

  renderPrevButton() {
    return html`
      <button type="button"
              class="slider-control-button"
              ?disabled=${this.currentSlide === 1}
              aria-labelledby="prev-button-label"
              @click=${this._dispatchPrevSlide}>
        ${this.renderIcon('chevron-left')}
        <span id="prev-button-label" hidden>${this.prevLabel}</span>
      </button>
    `;
  }

  renderNextButton() {
    return html`
      <button class="slider-control-button"
              ?disabled=${this.currentSlide === this.totalSlides}
              aria-labelledby="next-button-label" 
              @click=${this._dispatchNextSlide}>
        ${this.renderIcon('chevron-right')}
        <span id="next-button-label" hidden>${this.nextLabel}</span>
      </button>
    `;
  }

  renderIcon(icon: string) {
    return html`
      <div class="icon-wrapper" part="icon">
        <sbk-icon size="20" symbol=${icon}></sbk-icon>
      </div>
    `;
  }

  renderSlideIndicators() {
    const current = this.currentSlide < 10 ? '0' + this.currentSlide : this.currentSlide;
    const total = this.totalSlides < 10 ? '0' + this.totalSlides : this.totalSlides;
    return html`
      <div class="indicators">
        <span class="current">${current}</span>
        <span>/</span>
        <span>${total}</span>
      </div>
    `;
  }

  private _dispatchPrevSlide() {
    const options = {
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent('sbk-slider-control-prev-slide', options));
  }

  private _dispatchNextSlide() {
    const options = {
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent('sbk-slider-control-next-slide', options));
  }

}